const guiColors = {
    'motion-primary': '#ff9b86',
    'motion-primary-transparent': '#ff9b86e6',
    'motion-tertiary': '#cc7a69',

    'looks-secondary': '#ff9b86',
    'looks-transparent': '#ff9b8659',
    'looks-light-transparent': '#ff9b8626',
    'looks-secondary-dark': '#cc7a69',

    'extensions-primary': '#ff9b86',
    'extensions-tertiary': '#cc7a69',
    'extensions-transparent': '#ff9b8659',
    'extensions-light': '#ffcbbd',

    'drop-highlight': '#ffccb8'
};

const blockColors = {
    checkboxActiveBackground: '#ff9b86',
    checkboxActiveBorder: '#cc7a69'
};

export {
    guiColors,
    blockColors
};